const header = $('header')
const header_height = header.outerHeight()
const topLimit = header_height * 1.5
let prevScrollTop = $(this).scrollTop()
let initalLoad = true
let isHomePage = $('#hero-video').length

if(!isHomePage) {
  header.addClass('inner-page')
}

/**
 * Define header actions when scrolling
 * @param event
 */
function animate_page_header (event) {

  let scrollTop = $(this).scrollTop()
    if (scrollTop < 0) scrollTop = 0

  if (!initalLoad) {

    if (scrollTop > topLimit) {
      header.addClass('scroll')
      if (!header.hasClass('open')) {
        header.css('top', '-100%')
      }
    } else {
      header.removeClass('scroll')
      header.css('top', '0')
    }

    mobileFixedHeaderVisibility()

    let dir = scrollTop > prevScrollTop ? 1 : -1
    if (scrollTop <= 0) dir = -1

    if (dir === 1) {
      if (!header.hasClass('open')) {
        header.css('top', '-100%')
      }
    }

    if (dir === -1) {
      header.css('top', '0')
    }

    prevScrollTop = scrollTop
  } else {
    if (scrollTop > topLimit) {
      header.addClass('scroll')
    }
  }

  initalLoad = false
}

/**
 *
 */
function changeMobileMenu () {
  $('.hamburger').toggleClass('is-active')
  $('.page-header').toggleClass('open')
  $('html').toggleClass('popup-open')
  $('.mobile-menu-container').slideToggle()
  mobileFixedHeaderVisibility()
}

/**
 *
 */
function mobileFixedHeaderVisibility () {
  let page_header = $('.page-header')

  if (page_header.hasClass('scroll') && !page_header.hasClass('open')) {
    $('.mobile-fixed-footer').removeClass('hidden')
  } else {
    $('.mobile-fixed-footer').addClass('hidden')
  }
}

/**
 * Event setup
 */
animate_page_header()
window.addEventListener('scroll', animate_page_header)

$('body').on('click', '#js-open-responsive-menu', function (e) {
  //e.preventDefault()
  changeMobileMenu()
})
$('body').on('click', '.js-mobile-top-menuel', function (e) {
    //e.preventDefault()
    changeMobileMenu()
})
